import { GET_COUNTRIES } from 'modules/v2/store/constants';

export const getCountries = () => ({
  type: GET_COUNTRIES,
});
